"use client";

import { cn } from "@acme/ui";
import { CodemodAILogo } from "@acme/ui/logo";
import { Toggle } from "@acme/ui/toggle";

import { useCodemodAiPanel } from "../(studio)/studio/_hooks/use-codemod-ai-panel";

export function CodemodAiTrigger({ className }: { className?: string }) {
  const [aiModalOpen, setAiModalOpen] = useCodemodAiPanel();

  return (
    <Toggle
      variant="outline"
      className={cn(
        "text-primary inline-flex items-center font-medium",
        className,
      )}
      size="xs"
      onClick={() => setAiModalOpen((prev) => (prev ? null : "new"))}
      pressed={!!aiModalOpen}
    >
      <CodemodAILogo className="size-4" />
      <span className="text-nowrap">Codemod AI</span>
    </Toggle>
  );
}
